<template lang="pug">
  header.theHeader(v-if="layout.page.title")
    .titleBar(v-if='inputOver != true')
      h1.title {{ layout.page.title }}
      .subtitle.clock Agora: {{ $moment(now).format('DD/MM/YYYY HH:mm:ss') }}
      .subtitle(v-if="subtitle") {{ subtitle }}
    //- .actions
      i.fas.fa-search.icon(@click='overInput')
      el-input.inputover(
        placeholder='Buscar...',
        v-model='input',
        v-if='inputOver == true')
</template>

<script>
export default {
  name: 'TheHeader',
  data() {
    return {
      scrolled: 0,
      scrolledAux: 0,
      elHeader: false,
      input: '',
      inputOver: false,
      now: new Date(),
      timer: null,
    }
  },
  computed: {
    layout() {
      return this.$store.state.layout
    },
    category() {
      const { path } = this.$route
      if (path === '/coaching' || path.startsWith('/coaching/coachee'))
        return 'routePlan'
      if (path.startsWith('/coaching')) return 'coaching'
      return null
    },
    subtitleCoaching() {
      // eslint-disable-next-line
      const {now} = this
      const { lastUpdate, updating } = this.$store.state.offline.coaching
      if (updating) return 'Enviando dados...'
      const when = !lastUpdate ? 'nunca' : this.$moment(lastUpdate).fromNow()
      return `Ultimo envio: ${when}`
    },
    subtitleRoutePlan() {
      // eslint-disable-next-line
      const {now} = this
      const { lastUpdate, updating } = this.$store.state.offline.routePlan
      if (updating) return 'Atualizando...'
      const when = !lastUpdate ? 'nunca' : this.$moment(lastUpdate).fromNow()
      return `Ultima atualização: ${when}`
    },
    subtitle() {
      switch (this.category) {
        case 'coaching':
          return this.subtitleCoaching
        case 'routePlan':
          return this.subtitleRoutePlan
        default:
          return null
      }
    },
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = new Date()
    }, 1000)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    clearInterval(this.timer)
  },
  methods: {
    overInput() {
      this.inputOver = !this.inputOver
    },
    handleScroll() {
      this.scrolled = window.scrollY
      this.elHeader = document.getElementsByClassName('theHeader')[0]

      if (this.scrolled < this.scrolledAux) {
        this.elHeader?.classList.add('theHeaderTop')
      } else {
        this.elHeader?.classList.remove('theHeaderTop')
      }
      this.scrolledAux = this.scrolled
    },
  },
}
</script>

<style lang="sass" scoped>
.theHeader
  background-color: #FFFFFF
  display: flex
  align-items: center
  justify-content: space-between
  padding: 15px
  border-bottom: 1px solid var(--bgColor)
.theHeaderTop
  top: 0
  z-index: 9
  position: sticky
.title
  color: var(--primaryColor)
  font:
    size: 1.6em
    weight: 600
  transition: filter .7s
  body.offline &
    filter: saturate(0)
.subtitle
  margin-top: 4px
  color: var(--textColor)
  font-size: .6em
.clock
  margin-top: 8px
.icon
  font-size: 24px
  color: var(--primaryColor)
  margin: 8px auto;
  width: 7vw
  float: right
.inputover
  width: 83vw
</style>
